<template>
  <div class="bg-blue-100 rounded">
    <div class="text-xs px-3 py-2">
      <span v-if="user">{{ user.fullName }}</span>
      <span class="font-normal"> &bull;</span>
      {{ createdAt }}
    </div>
    <div class="text-sm px-3 py-2">
      {{ comment.content }}
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ApprovalRequestLineCommentLine',
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    user() {
      if (!(this.comment.userId in this.$store.state.entities.users.byId)) {
        return null;
      }

      return this.$store.state.entities.users.byId[this.comment.userId];
    },
    createdAt() {
      return moment(this.comment.createdAt).fromNow();
    },
  },
};
</script>
